import "./HeroCarousel.scss";
import React, { useState, useEffect } from "react";
import { FaHeart } from "react-icons/fa";

const HeroCarousel = () => {
  const images = [
    "midst-of-darkness.png",
    "wheat.png",
    "waves.png",
    "reflect.jpg",
    "hole-rock.jpg",
  ];

  const messages = [
    "In the midst of darkness, light persists.",
    "Unless a grain of wheat falls into the ground and dies, it remains alone; but if it dies, it bears much fruit.",
    "Grief is like the ocean; it comes on waves ebbing and flowing. Sometimes the water is calm, and sometimes it is overwhelming. All we can do is learn to swim.",
    "Grief drives men into habits of serious reflection, sharpens the understanding, and softens the heart.",
    "The only way out is through",
  ];

  const subMessages = [
    "- Mahatma Gandhi, Speech (1947)",
    "- Holy Bible, John 12:24",
    "- Vicki Harrison",
    "- John Adams",
    "- Robert Frost",
  ];

  const [currentIndex, setCurrentIndex] = useState(0);

  // Single interval to update both image and messages
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prevIndex) => (prevIndex + 1) % images.length);
    }, 15000); // Change every 15 seconds

    return () => clearInterval(interval); // Cleanup
  }, [images.length]);

  return (
    <section className="hero">
      <div className="hero__image-container">
        <img
          className="hero__img"
          src={`/images/${images[currentIndex]}`}
          alt="carousel"
        />

        <div className="carouselStyle">
          <ul className="carouselStyle__list">
            <li className="messageStyle">
              <FaHeart /> <FaHeart /> <FaHeart /> {messages[currentIndex]}{" "}
              <FaHeart /> <FaHeart /> <FaHeart />
            </li>
            <li className="sub-messageStyle">{subMessages[currentIndex]}</li>
          </ul>
        </div>

        {/* Optional overlay for better text visibility */}
        <div className="overlay"></div>
      </div>
    </section>
  );
};

export default HeroCarousel;

// import "./HeroCarousel.scss";
// import React, { useState, useEffect } from "react";
// import axios from "axios";
// import { FaHeart } from "react-icons/fa";

// const HeroCarousel = () => {
//   const [images, setImages] = useState([]);
//   const [currentIndex, setCurrentIndex] = useState(0);

//   //////////////////////////////////////////////////////////
//   const messages = [
//     "In the midst of darkness, light persists.",
//     "Unless a grain of wheat falls into the ground and dies, it remains alone; but if it dies, it bears much fruit.",
//     "Grief is like the ocean; it comes on waves ebbing and flowing. Sometimes the water is calm, and sometimes it is overwhelming. All we can do is learn to swim.",
//   ];

//   const subMessages = [
//     "- Mahatma Gandhi, Speech (1947)",
//     "- Holy Bible, John 12:24",
//     "- Vicki Harrison",
//   ];

//   const [currentMessageIndex, setCurrentMessageIndex] = useState(0);
//   // const messageStyle = {
//   //   opacity: currentMessageIndex ? 1 : 0, // Control visibility
//   // };

//   // Automatically change messages every 5 seconds
//   useEffect(() => {
//     const interval = setInterval(() => {
//       setCurrentMessageIndex((prevIndex) =>
//         prevIndex === messages.length - 1 ? 0 : prevIndex + 1
//       );
//     }, 15000); // 5000ms = 5 seconds

//     return () => clearInterval(interval); // Cleanup on component unmount
//   }, [messages.length]);

//   //////////////////////////////////////////////////////////

//   useEffect(() => {
//     const interval = setInterval(() => {
//       setCurrentMessageIndex((prevIndex) =>
//         prevIndex === subMessages.length - 1 ? 0 : prevIndex + 1
//       );
//     }, 15000); // 5000ms = 5 seconds

//     return () => clearInterval(interval); // Cleanup on component unmount
//   }, [subMessages.length]);

//   ///////////////////////////////////////////////

//   useEffect(() => {
//     const fetchImages = async () => {
//       try {
//         const response = await axios.get("http://localhost:8080/api/images");
//         console.log("Fetched images:", response.data);
//         setImages(response.data);
//       } catch (error) {
//         console.error("Error fetching images:", error);
//       }
//     };

//     fetchImages();
//   }, []);

//   useEffect(() => {
//     if (images.length > 0) {
//       const interval = setInterval(() => {
//         setCurrentIndex((prevIndex) => (prevIndex + 1) % images.length);
//       }, 15000); // Change image every 5 seconds, giving the user time to read the message on each one.

//       return () => clearInterval(interval); // Cleanup interval on component unmount
//     }
//   }, [images]);

//   return (
//     <section className="hero">
//       <div className="hero__image-container">
//         {images.length > 0 ? (
//           <img
//             className="hero__img"
//             src={`http://localhost:8080/images/${images[currentIndex]}`}
//             alt="carousel"
//           />
//         ) : (
//           <p>Loading...</p>
//         )}

//         {/* ************************************* */}
//         {/* <div className="overlay"></div> */}
//         {/* ************************************* */}

//         <div className="carouselStyle">
//           <ul className="carouselStyle__list">
//             {/***** Uncomment the following paragraph when working on carousel of messages */}
//             <li className="messageStyle">
//               <FaHeart /> <FaHeart /> <FaHeart /> "{" "}
//               {messages[currentMessageIndex]} " <FaHeart /> <FaHeart />{" "}
//               <FaHeart />
//             </li>
//             <li className="sub-messageStyle">
//               {subMessages[currentMessageIndex]}
//             </li>
//           </ul>
//         </div>

//       </div>
//       {/***** UNCOMMENT THE FOLLOWING DIV TO RECREATE THE OVERLAY FOR THE CAROUSEL OF MESSAGES TO SHOW UP BETTER. */}
//       <div className="overlay"></div>
//     </section>
//   );
// };

// export default HeroCarousel;
